import { BlockRelationship } from '.'
import { AtLeast } from '../../helpers'

// Extract just the base part of a fractional index, removing the tiebreaker
export function extractBaseOrder(order: string): string {
  // Skip very short strings (edge case protection)
  if (order.length < 4) return order

  // Remove the last 4 characters which contain the tiebreaker
  return order.slice(0, -4)
}

export type BlockRelationshipForHash = AtLeast<
  BlockRelationship,
  'order' | 'parentId' | 'blockId' | 'sourceBlockId'
>

export function hashBr(br: BlockRelationshipForHash): string {
  return `${br.blockId}__${br.sourceBlockId}__${br.parentId}__${extractBaseOrder(br.order)}`
}

export function areBRsCompatible(
  br1: BlockRelationshipForHash,
  br2: BlockRelationshipForHash
): boolean {
  if (br1.blockId !== br2.blockId) return false
  if (br1.sourceBlockId !== br2.sourceBlockId) return false
  if (br1.parentId !== br2.parentId) return false
  if (extractBaseOrder(br1.order) !== extractBaseOrder(br2.order)) return false

  return true
}

export function getBRId(blockId: string, rootBlockId: string) {
  return `${rootBlockId}__${blockId}`
}
